import meridianTypes from './meridian.types';

export const initialState = {
  clients: {
    items: [],
    inactive_count: 0,
    pageOptions: { total: 0, page: 1, per_page: 20, pages: 0 }
  },
  clientDetails: {}
};

export const meridianReducer = (state = initialState, action) => {
  switch (action.type) {
    case meridianTypes.SET_MERIDIAN_CLIENTS:
      return {
        ...state,
        clients: action.payload
      };
    case meridianTypes.SET_MERIDIAN_CLIENT_DETAILS:
      return {
        ...state,
        clientDetails: action.payload
      };
    default:
      return state;
  }
};

export default meridianReducer;
